import { useState } from "react";

type Props = {
    image: string,
    imageWebp: string,
    backgroundClass: string,
};

const ProductLabel = ({
    image,
    imageWebp,
    backgroundClass,
}: Props) => {
    const [isZoomed, setIsZoomed] = useState(false);

    const toggleZoom = () => {
        setIsZoomed(!isZoomed);
    };

    return (
        <section id="product-label" className={`${backgroundClass} py-5`}>
            <div className="container-fluid">
                <div className="row justify-content-center align-items-center">
                    <div className="col-xl-5 col-lg-6 col-md-8 col-8 px-md-0 px-4 text-center gg-img-container-zoom">
                        <picture>
                            <source srcSet={imageWebp} type="image/webp" />
                            <img
                                className={`img-fluid gg-img-zoom ${isZoomed ? "gg-zoomed" : ""}`}
                                src={image}
                                alt="label"
                                onClick={toggleZoom}
                                loading="lazy"
                            />
                        </picture>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProductLabel;